import type * as core from '../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.submonitoring.riskAssessment',
    'resource:solutions.apps.sr',
    'resource:solutions.apps.sr.pages.awards',
    'resource:solutions.apps.sr.pages.subawards',
    'resource:solutions.apps.sr.pages.subrecipients',
    'resource:solutions.apps.sr.pages.externalInstitutions',
    'resource:solutions.apps.sr.pages.conditions',
    'resource:solutions.apps.sr.pages.awardDetails',
    'resource:solutions.apps.sr.pages.subawardDetails',
    'resource:solutions.apps.sr.pages.subrecipientDetails',
    'resource:solutions.mosaic.actions.sr.deleteAward',
    'resource:solutions.mosaic.actions.sr.deleteExternalInstitution',
    'resource:solutions.mosaic.actions.sr.deleteMonitoringActivity',
    'resource:solutions.mosaic.actions.sr.deleteSubrecipient',
    'resource:solutions.mosaic.actions.sr.deleteTerm',
    'resource:solutions.mosaic.actions.sr.openEditExternalInstitutionModal',
    'resource:solutions.mosaic.actions.sr.saveAward',
    'resource:solutions.mosaic.actions.sr.saveExternalInstitution',
    'resource:solutions.mosaic.actions.sr.saveMonitoringActivity',
    'resource:solutions.mosaic.actions.sr.saveRiskAssessment',
    'resource:solutions.mosaic.actions.sr.saveSubaward',
    'resource:solutions.mosaic.actions.sr.saveSubawardRiskAssessment',
    'resource:solutions.mosaic.actions.sr.saveSubrecipient',
    'resource:solutions.mosaic.actions.sr.saveTerm',
    'resource:solutions.mosaic.pages.sr.awards',
    'resource:solutions.mosaic.pages.sr.subawards',
    'resource:solutions.mosaic.pages.sr.subrecipients',
    'resource:solutions.mosaic.pages.sr.externalInstitutions',
    'resource:solutions.mosaic.pages.sr.conditions',
    'resource:solutions.mosaic.pages.sr.awardDetails',
    'resource:solutions.mosaic.pages.sr.subawardDetails',
    'resource:solutions.mosaic.pages.sr.subrecipientDetails',
    'resource:solutions.mosaic.widgets.sr.awardDetailsInfo',
    'resource:solutions.mosaic.widgets.sr.projectsTable',
    'resource:solutions.mosaic.widgets.sr.awardsTable',
    'resource:solutions.mosaic.widgets.sr.editAward',
    'resource:solutions.mosaic.widgets.sr.activitiesTable',
    'resource:solutions.mosaic.widgets.sr.editActivity',
    'resource:solutions.mosaic.widgets.sr.editTerm',
    'resource:solutions.mosaic.widgets.sr.termsTable',
    'resource:solutions.mosaic.widgets.sr.editExternalInstitution',
    'resource:solutions.mosaic.widgets.sr.externalInstitutionsTable',
    'resource:solutions.mosaic.widgets.sr.award',
    'resource:solutions.mosaic.widgets.sr.computedRiskLevel',
    'resource:solutions.mosaic.widgets.sr.subawardDetailsInfo',
    'resource:solutions.mosaic.widgets.sr.overrideRiskLevel',
    'resource:solutions.mosaic.widgets.sr.riskAssessmentSurvey',
    'resource:solutions.mosaic.widgets.sr.subawardRiskScore',
    'resource:solutions.mosaic.widgets.sr.subrecipientRiskScore',
    'resource:solutions.mosaic.widgets.sr.editSubawards',
    'resource:solutions.mosaic.widgets.sr.subawardsTable',
    'resource:solutions.mosaic.widgets.sr.subrecipientDetailsInfo',
    'resource:solutions.mosaic.widgets.sr.institutionalRiskAssessmentSurvey',
    'resource:solutions.mosaic.widgets.sr.institutionalRiskAssessmentsTable',
    'resource:solutions.mosaic.widgets.sr.editSubrecipients',
    'resource:solutions.mosaic.widgets.sr.subrecipientsTable',
  ],
  description:
    'Subrecipient monitoring application resources and supporting research administration data.',
  name: 'Subrecipient Monitoring',
} as const satisfies core.quiver.Package
